/**
* *
* ! call search template
*/
<template>
  <div class="animated fadeIn">
    <Search
      :url="url"
      ref="searchPersonExam"
      :title="$lang.person_examPack"
      :remove_item="remove_item"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :visibleAdd="false"
      :allowEdit="false"
      :dynamicButtons="buttons"
      :visibleSearch="false"
      :visibleSettings="false"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="false"
      :visibleAccordion="true"
      :allowFields="$lang.searchPersonExamPack"
      :itemTopHeader="itemTopHeader"
      @getPermisson="updatePermissions"
    >
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="showAzmoonLinksModal"
      size="xl"
      ok-only
      hide-header
      :ok-title="$lang.close"
    >
      <AzmoonExecuteLinks
        :azmoonExecuteId="azmoon_execute_id"
        :personCode="person_code"
        :operatorCode="operator_code"
        :referenceCode="reference_code"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AzmoonExecuteLinks from "@/components/global/AzmoonExecuteLinks";
import { pathOr } from "ramda";

export default {
  name: "search-person-exam",
  components: {
    Search,
    AzmoonExecuteLinks,
  },
  data() {
    return {
      url:
        this.$config.api_url +
        this.$config.profile.person_azmoon.replace(
          "{0}",
          this.$route.params.code
        ),

      buttons: [
        {
          id: "0",
          name: "views_all_azmoon_exampack",
          click: this.azmmonExamPack,
          text: this.$lang.views_all_azmoon_exampack,
        },
      ],
      azmoon_execute_id: null,
      person_code: null,
      reference_code: null,
      operator_code: null,
      showAzmoonLinksModal: false,
      itemTopHeader: [
        {
          colspan: 3,
          name: this.$lang.term,
          variant: "info",
        },
        {
          colspan: 3,
          name: this.$lang.azmoon,
        },
        {
          colspan: 2,
          name: this.$lang.person_exam,
          variant: "info",
        },
        {
          colspan: 2,
          name: this.$lang.assessor,
        },
      ],
    };
  },
  methods: {
    pathOr,
    azmmonExamPack(item) {
      this.azmoon_execute_id = item.azmoon.azmoon_execute_id;
      this.person_code = pathOr(null, ["person", "parvandeh", "code"], item);
      this.operator_code = pathOr(
        null,
        ["operator", "parvandeh", "code"],
        item
      );
      this.reference_code = pathOr(null, ["reference", "code"], item);

      if (!this.person_code || !this.operator_code) {
        return this.$notify.error(
          "برای دیدن لیست پرسشنامه‌ها شماره پرونده برای متقاضی و ارزیاب باید پر باشد"
        );
      }

      this.showAzmoonLinksModal = true;
    },
    /**
     * *
     * ! remove each row in table
     * @param myparam item type object have all row data
     */
    async remove_item(item) {
      try {
        const url = `${this.url}/${item.id}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        return true;
      } catch (error) {
        this.$generateError(error);
        throw "error";
      }
    },
    updatePermissions(data) {
      this.$emit("getPermissions", data);
    },
  },
};
</script>
